export default {"src":"/_next/static/media/WhoWeAre_017A.77d85a4a.JPG","height":688,"width":1920};